import React, { useState } from 'react';
import Chakra from './Chakra';
import { TRICOLOR_THEME_ENABLED } from '../themeConfig';
import './IndependenceBanner.css';

// Festive announcement bar shown above the header while the tricolour
// (Independence Day) theme is active. Dismissible for the current session.
function IndependenceBanner() {
  const [open, setOpen] = useState(true);

  if (!TRICOLOR_THEME_ENABLED || !open) return null;

  return (
    <div className="iday-banner" role="banner">
      <div className="iday-banner__inner">
        <Chakra size={18} color="#000080" className="iday-banner__chakra" />
        <span className="iday-banner__text">
          Celebrating India's <strong>80th Independence Day</strong>
          <span className="iday-banner__dot"> · </span>
          <span className="iday-banner__date">15 August</span>
        </span>
        <button
          className="iday-banner__close"
          onClick={() => setOpen(false)}
          aria-label="Dismiss Independence Day banner"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default IndependenceBanner;
